import React from "react";
import "./GalleriesFlat.scss";
import img1 from "../../assets/galleries/flat4/img1.jpg";
import img2 from "../../assets/galleries/flat4/img2.jpg";

function GalleryFlat4() {
  return (
    <section className="galleryFlat1 galleryFlat4">
      <div className="galleryFlat1__photo1">
        <img className="galleryFlat1__photo1__img" src={img1} alt="" />
      </div>

      <div className="galleryFlat1__photo2">
        <img className="galleryFlat1__photo2__img" src={img2} alt="" />
        <p className="galleryFlat1__copy galleryFlat__copy">
          Roberto Coin admires the completed Love in Verona bracelet collection.
        </p>
      </div>
    </section>
  );
}

export default GalleryFlat4;
